import React from "react";
import { Layout, Menu } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { SIDE_NAV_WIDTH, SIDE_NAV_DARK, NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import { Scrollbars } from 'react-custom-scrollbars';
import MenuContent from './MenuContent'
import { signOut } from 'redux/actions/Auth';

const { Sider } = Layout;

export const SideNav = ({navCollapsed, sideNavTheme, routeInfo, hideGroupTitle, localization = true, signOut }) => {
  const props = { sideNavTheme, routeInfo , hideGroupTitle, localization}
  return (
    <Sider
      className={`side-nav ${sideNavTheme === SIDE_NAV_DARK? 'side-nav-dark' : ''}`}
      width={SIDE_NAV_WIDTH}
      collapsed={navCollapsed}
      style={{ display: 'flex', flexDirection: 'column', height: '100vh', position: 'fixed' }}
    >
      <div style={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
        <Scrollbars autoHide>
          <MenuContent
            type={NAV_TYPE_SIDE}
            {...props}
          />
        </Scrollbars>
      </div>
      <Menu
        theme={sideNavTheme === SIDE_NAV_DARK ? 'dark' : 'light'}
        mode="inline"
        selectable={false}
      >
        <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={signOut}>
          Cerrar sesión
        </Menu.Item>
      </Menu>
    </Sider>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme } =  theme;
  return { navCollapsed, sideNavTheme }
};

export default connect(mapStateToProps, { signOut })(SideNav);
